import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useGetUserInformation } from "../../features/users";
import { profileNotificationDefaultValues } from "../../lib/constants";
import {
  useGetNotificationSetting,
  useUpdateNotificationSetting,
} from "../../lib/queries/queriesAndMutations";
import { cn } from "../../utils/utils";
import Switch from "../shared/Checkbox/Switch";

const NoticeSettings = [
  // {
  //   type: "email",
  //   key: "email_on_settlement",
  //   label: "تسویه‌حساب‌ها",
  //   description:
  //     "برای هر وجهی که از حساب‌های شما خارج می‌شود یک اعلان دریافت خواهید کرد.",
  // },
  // {
  //   type: "email",
  //   key: "email_on_settlement_change",
  //   label: "واریز‌ها",
  //   description:
  //     "برای هر وجهی که به حساب‌های شما واریز می‌شود یک اعلان دریافت خواهید کرد.",
  // },
  // {
  //   type: "sms",
  //   key: "sms_on_login",
  //   label: "تسویه‌حساب‌ها",
  //   description:
  //     "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  // },
  // {
  //   type: "sms",
  //   key: "sms_on_settlement",
  //   label: "تسویه‌حساب‌ها",
  //   description:
  //     "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  // },
  {
    type: "email",
    key: "email_on_login",
    label: "ورود به پنل کاربری",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_business_denial",
    label: "رد شدن درخواست کسب و کار",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_broad_notification",
    label: "اعلانات عمومی",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_news",
    label: "اخبار",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_gateway_approval",
    label: "تاییدشدن درگاه ها",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_message",
    label: "پیام های شخصی کاربر",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_gateway_denial",
    label: "رد شدن درخواست درگاه ها",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_tickey",
    label: "پشتیبانی",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_account_approval",
    label: "تایید شدن حساب بانکی",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_failed_login",
    label: "عدم ورود به ناحیه کاربری",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_account_denial",
    label: "رد شدن درخواست حساب بانکی",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_verify",
    label: "تایید شدن حساب کاربری",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_form_approval",
    label: "تایید شدن درخواست فرم",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_settlement",
    label: "تسویه‌حساب‌ها",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_failed_verify",
    label: "رد شدن حساب بانکی",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_form_denial",
    label: "رد شدن درخواست فرم",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_transaction",
    label: "تراکنش ها",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_business_approval",
    label: "تایید شدن کسب و کار",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
  {
    type: "email",
    key: "email_on_settlement_change",
    label: "تغییر تسویه ها",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
  },
];

export default function PortForm() {
  const navigate = useNavigate();
  const { data: user } = useGetUserInformation();
  const userId = user?.id;
  const { data: setting } = useGetNotificationSetting(userId);
  const { mutateAsync: updateSetting } = useUpdateNotificationSetting();

  const {
    handleSubmit,
    control,
    watch,
    formState: { isDirty },
  } = useForm({
    defaultValues: profileNotificationDefaultValues,
    values: setting?.data,
  });

  const handleSave = async (formData) => {
    try {
      const response = await updateSetting({ userId, updatedData: formData });
      if (response.status === 200) {
        toast.success("فرم پرداخت با موفقیت ثبت گردید");
        navigate(`/forms/list/`);
      }
    } catch (error) {
      toast.error("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
    }
  };

  useEffect(() => {
    if (isDirty) {
      console.log(watch());
    }
  }, [watch, isDirty]);

  return (
    <div className="flex gap-2">
      <div className="flex-1 flex flex-col gap-4 px-2 rounded-md p-2">
        <form onSubmit={handleSubmit(handleSave)} className="grid grid-cols-1 gap-4 pb-4">
          {NoticeSettings.map((item) => (
            <CheckboxInput
              key={item.key}
              control={control}
              name={item.key}
              label={item.label}
              description={item.description}
            />
          ))}
          <button type="submit" className="btn-primary mt-4 mr-auto bg-dark text-white p-2 rounded-md">
            ذخیره
          </button>
        </form>
      </div>
    </div>
  );
}

const CheckboxInput = ({ control, name, label, description }) => (
  <div className={cn("flex flex-col bg-neutral-10 md:bg-white p-2 rounded-md gap-3")}>
    <div className="flex justify-between items-center">
      <label className="text-[16px] font-bold">{label}</label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => <Switch value={value} onChange={onChange} />}
      />
    </div>
    <label className="text-[14px] text-dark text-opacity-60">{description}</label>
  </div>
);

// import React, { useEffect, useState } from "react";
// import ToggleOption from "../ToggleOption";
// import { useSelector } from "react-redux";
// import { EmailNoticeSetting, SmsNoticeSetting } from "../../lib/constants";
// import { useGetNotificationSetting } from "../../lib/queries/queriesAndMutations";

// const ProfileNoticeSetting = () => {
//  const NoticeSetting = [
//   {
//     type: "email",
//     key: "email_on_settlement",
//     label: "تسویه‌حساب‌ها",
//     description:
//       "برای هر وجهی که از حساب‌های شما خارج می‌شود یک اعلان دریافت خواهید کرد.",
//     active"},
//   },
//   {
//     type: "email",
//     id: "email_on_settlement_change",
//     label: "واریز‌ها",
//     description:
//       "برای هر وجهی که به حساب‌های شما واریز می‌شود یک اعلان دریافت خواهید کرد.",
//     active"},
//   },
//   {
//     type: "sms",
//     key: "sms_on_login",
//     label: "تسویه‌حساب‌ها ",
//     description:
//       "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
//     active"},
//   },
//   {
//     type: "sms",
//     key: "sms_on_settlement",
//     label: "تسویه‌حساب‌ها",
//     description:
//       "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
//     active"},
//   },

// ];

// const userId = useSelector((store) => store.authSlice.userData.id);
//   const [isEmail, setIsEmail] = useState(false);

//   const [settings, setSettings] = useState(EmailNoticeSetting);
// const {data:setting}= useGetNotificationSetting(userId);

//   console.log({settings})

//   const handleToggle = (id, type) => {
//     setSettings((prev) =>
//       prev.map((setting) =>
//         setting.id === id ? { ...setting, [type]: !setting[type] } : setting
//       )
//     );
//   };

//   useEffect(() => {
//     setSettings(setting.da);
//   }, [setting]);

//   return (
//     <div className="w-full h-full justify-center items-center p-2 rounded-v-lg">
//       <div className="w-full flex items-center justify-center">
//         <ToggleOption
//           toggleType="double"
//           fixedAmount={isEmail}
//           trueValue="رایانامه"
//           falseValue="پیام کوتاه"
//           handleSwitchT={() => setIsEmail(true)}
//           handleSwitchF={() => setIsEmail(false)}
//         />
//       </div>

//       <div>
//         {/* {settings.map((setting) => (
//           <div
//             key={setting.id}
//             className="w-full flex justify-between items-center border-b-2 border-neutral-20 p-2 mb-2"
//           >
//             <div className="flex flex-col justify-center items-start gap-2">
//               <p className="text-[16px] font-semibold">{setting.label}</p>
//               <p className="text-[12px]">{setting.description}</p>
//             </div>
//            <div className="min-w-fit">
//            <ToggleSwitch
//               cheked={isEmail ? setting.email : setting.sms}
//               clickHandler={() => handleToggle(setting.id, isEmail ? "email" : "sms")}
//             />
//            </div>
//           </div>
//         ))} */}
//       </div>
//     </div>
//   );
// };

// export default ProfileNoticeSetting;
